import requestReducer from '../requestReducer';
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import CurrentAccount from '../../models/CurrentAccount';


export interface CurrentAccountDetailState extends PaginatedApiState {
  currentAccountLines?: CurrentAccount[]
}

const CurrentAccountDetail = (state: CurrentAccountDetailState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<CurrentAccountDetailState>('CURRENT_ACCOUNT_DETAIL')(state, action)
  }
}

export default CurrentAccountDetail